// extracted by mini-css-extract-plugin
module.exports = {"headerStyle":"ModalHeader_headerStyle__3TWY5","headerWithTitle":"ModalHeader_headerWithTitle__2rnRK"};